export const name = 'viewerManagerScrollApi' as const

export const RootScrollApiSymbol = Symbol('RootScrollApi')
